import React from 'react'
import { graphql, Link, useStaticQuery } from "gatsby"
import { useTranslation } from 'gatsby-plugin-react-i18next';

import { Element, Image } from "components/shared/base"
import Navigation from "./Navigation"


const Header: React.FC = (): React.ReactElement | null => {

  const headerQuery = useStaticQuery(graphql`
    query {
      allPrismicNavigation {
        edges {
          node {
            data {
              title {
                text
              }
              logo {
                alt
                gatsbyImageData
                url
              }
              top_navigation {
                link {
                  type
                  slug
                  id
                  link_type
                  url
                }
                link_label
              }
            }
          }
        }
      }
    }
  `)

  const { t } = useTranslation("shared");

  const headerData = headerQuery && headerQuery?.allPrismicNavigation;

  const headerNodeData = headerData?.edges[0]?.node?.data;

  if(!headerNodeData) {
    return null
  }

  const {
   logo,
   top_navigation
  } = headerNodeData;

  return (
    <Element
      as="header"
      className="site-header"
      display="flex"
      fontFamily="karla"
      fontSize={["text.primaryMobile", "text.primary"]}
      m="0 auto"
      maxWidth="maxWidth"
      p={["15px 50px", "30px 50px"]}
    >
      <Element marginLeft={["auto", "0"]} >
        {logo && (
          <Link to="/">
            <Image
              alt={t('logo')}
              image={logo.gatsbyImageData}
              maxwidth={["iconMobile", "iconDesktop"]}
              width="auto"
            />
          </Link>
        )}
      </Element>
      {top_navigation && (
        <Navigation navigationLinks={top_navigation} />
      )}
    </Element>
  )
}

export default Header
